import React, { useEffect } from 'react';
import { Box, Grid, Typography, InputBase, Select, MenuItem, FormControl, Divider } from '@mui/material';
import { useTranslation } from "react-i18next";
import { DropDownIcon } from '../../../Components/Layouts/CustomIcons';

function ScreenInformationSection({ formData, setFormData, errors, setErrors, inputBoxColor, textColor, errorColor, subHeadingGrey, dropCircle, dropIcon }) {
    // Ensure at least one screen exists in the screens array
    useEffect(() => {
        if (!formData.screens || formData.screens.length === 0) {
            setFormData({
                ...formData,
                screens: [{ width: '', height: '', resolution: '', displayType: 'LCD' }],
            });
        }
    }, [formData, setFormData]);

    const handleScreenChange = (index, field, value) => {
        const updatedScreens = [...formData.screens];
        const updatedErrors = { ...errors };

        if (field === 'resolution') {
            // Extract numbers and format into "width x height"
            const cleanedValue = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
            if (cleanedValue.length <= 4) {
                updatedScreens[index] = { ...updatedScreens[index], [field]: cleanedValue }; // Keep typing first part
            } else {
                const width = cleanedValue.slice(0, cleanedValue.length / 2);
                const height = cleanedValue.slice(cleanedValue.length / 2);
                updatedScreens[index] = { ...updatedScreens[index], [field]: `${width}x${height}` };
            }

            // Validate resolution format
            const formattedValue = updatedScreens[index][field];
            if (!/^\d+x\d+$/.test(formattedValue)) {
                if (!updatedErrors.screens) updatedErrors.screens = [];
                if (!updatedErrors.screens[index]) updatedErrors.screens[index] = {};
                updatedErrors.screens[index][field] = t("vendingMachines.Resolutionmust");
            } else if (updatedErrors.screens?.[index]?.[field]) {
                delete updatedErrors.screens[index][field];
                if (Object.keys(updatedErrors.screens[index]).length === 0) {
                    updatedErrors.screens.splice(index, 1);
                }
            }
        } else {
            updatedScreens[index] = { ...updatedScreens[index], [field]: value };

            // Validation for width and height
            if (field === 'width' || field === 'height') {
                if (!/^\d*\.?\d*$/.test(value)) {
                    if (!updatedErrors.screens) updatedErrors.screens = [];
                    if (!updatedErrors.screens[index]) updatedErrors.screens[index] = {};
                    updatedErrors.screens[index][field] = field === 'width' ? t("vendingMachines.Widthmustpositive") : t("vendingMachines.Heightmustpositive");
                } else if (updatedErrors.screens?.[index]?.[field]) {
                    delete updatedErrors.screens[index][field];
                    if (Object.keys(updatedErrors.screens[index]).length === 0) {
                        updatedErrors.screens.splice(index, 1);
                    }
                }
            }
        }

        setFormData({ ...formData, screens: updatedScreens });
        setErrors(updatedErrors);
    };
    const { t } = useTranslation();

    const handleNumberOfScreensChange = (e) => {
        const numberOfScreens = parseInt(e.target.value, 10);
        let updatedScreens = formData.screens;

        if (numberOfScreens > updatedScreens.length) {
            // Add new screen objects
            for (let i = updatedScreens.length; i < numberOfScreens; i++) {
                updatedScreens.push({
                    width: '',
                    height: '',
                    resolution: '',
                    displayType: 'LCD',
                });
            }
        } else if (numberOfScreens < updatedScreens.length) {
            // Remove extra screen objects
            updatedScreens = updatedScreens.slice(0, numberOfScreens);
        }

        setFormData({ ...formData, screens: updatedScreens });
    };
    const onlyPositiveNumberProps = {
        inputProps: {
            min: 1,
            inputMode: 'decimal',
            pattern: '[0-9]*[.,]?[0-9]*', // optional dot/comma for decimal
            onWheel: (e) => e.target.blur(),
        },
        onWheel: (e) => e.target.blur(),
        onKeyDown: (e) => {
            const allowed = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'];
            const isNumber = /^\d$/.test(e.key);
            const isDot = e.key === '.';
            const alreadyHasDot = e.target.value.includes('.');

            if (!isNumber && !allowed.includes(e.key)) {
                if (isDot && !alreadyHasDot) {
                    // Allow a single decimal point
                    return;
                }
                e.preventDefault();
            }
        },
        onPaste: (e) => {
            const pasted = e.clipboardData.getData('text');
            if (!/^\d*\.?\d*$/.test(pasted)) {
                e.preventDefault(); // Block non-decimal or negative values
            }
        }
    };

    return (
        <Box >
            {/* Number of Screens */}
            {/* <Grid container spacing={{ md: 10, lg: 10, xl: 25 }}>
                <Grid item xs={12} md={4} className='stategrid5'>
                    <p className="label-text-sec">{t("vendingMachines.NumberScreen")}</p>
                    <Box sx={{ backgroundColor: inputBoxColor, borderRadius: '8px', padding: '0.5rem 1rem' }}>
                        <FormControl fullWidth>
                            <Select
                                value={formData.screens?.length || 1}
                                onChange={handleNumberOfScreensChange}
                                displayEmpty
                                IconComponent={(props) => (
                                    <DropDownIcon color1={dropCircle} color2={dropIcon} {...props} />
                                )}
                                sx={{
                                    fontSize: '14px',
                                    color: textColor,
                                    backgroundColor: inputBoxColor,
                                    boxShadow: 'none',
                                    padding: 0,
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none',
                                    },
                                    '& .MuiSelect-select': {
                                         padding: '0.3rem 0.5rem',
                                        height: 'auto',
                                        display: 'flex',
                                        alignItems: 'center',
                                    },
                                }}
                            >
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
            </Grid> */}
            {/* <Divider className='card-border-sec' /> */}

            {/* Screen Details */}
            {formData.screens?.map((screen, index) => (
                <Box key={index} >
                    {/* <Typography className='machine-sub-header ' id="sub-header-margin" sx={{ color: subHeadingGrey, }}>
                        {t("vendingMachines.Screen")} {index + 1}
                    </Typography> */}
                    <Grid container spacing={12}>
                        <Grid item xs={12} md={4} id='vend-state10' className='stategrid5' >
                            {/* Width */}
                            <p className="label-text-sec">{t("vendingMachines.size")}*</p>
                            <Box sx={{
                                display: 'flex', alignItems: 'center', backgroundColor: inputBoxColor, borderRadius: '8px', padding: '0.5rem 1rem', '& input[type=number]': {
                                    MozAppearance: 'textfield', // Firefox
                                },
                                '& input[type=number]::-webkit-outer-spin-button': {
                                    WebkitAppearance: 'none',
                                    margin: 0,
                                },
                                '& input[type=number]::-webkit-inner-spin-button': {
                                    WebkitAppearance: 'none',
                                    margin: 0,
                                },
                            }}>
                                <InputBase
                                    value={screen.width || ''}
                                    type='number'
                                    onChange={(e) => handleScreenChange(index, 'width', e.target.value)}
                                    placeholder="0.0"
                                    fullWidth
                                    {...onlyPositiveNumberProps}
                                    sx={{ fontSize: '14px', color: textColor }}
                                />
                                <Typography sx={{ marginLeft: '5px', color: '#9CA3AF' }}>{t("vendingMachines.inches")}</Typography>
                            </Box>
                            {errors.screens?.[index]?.width && (
                                <Typography sx={{ color: errorColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.screens[index].width}
                                </Typography>
                            )}

                            {/* Height */}
                            {/* <p className="label-text-sec">{t("vendingMachines.Height")}*</p>
                            <Box sx={{
                                display: 'flex', alignItems: 'center', backgroundColor: inputBoxColor, borderRadius: '8px', padding: '0.5rem 1rem', '& input[type=number]': {
                                    MozAppearance: 'textfield', // Firefox
                                },
                                '& input[type=number]::-webkit-outer-spin-button': {
                                    WebkitAppearance: 'none',
                                    margin: 0,
                                },
                                '& input[type=number]::-webkit-inner-spin-button': {
                                    WebkitAppearance: 'none',
                                    margin: 0,
                                },
                            }}>
                                <InputBase
                                    value={screen.height || ''}
                                    type='number'
                                    onChange={(e) => handleScreenChange(index, 'height', e.target.value)}
                                    placeholder="0.0"
                                    fullWidth
                                    {...onlyPositiveNumberProps}
                                    sx={{ fontSize: '14px', color: textColor }}
                                />
                                <Typography sx={{ marginLeft: '5px', color: '#9CA3AF' }}>{t("vendingMachines.inches")}</Typography>
                            </Box>
                            {errors.screens?.[index]?.height && (
                                <Typography sx={{ color: errorColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.screens[index].height}
                                </Typography>
                            )} */}
                        </Grid>

                        <Grid className='resolution-div stategrid5' item xs={12} md={4}>
                            {/* Resolution */}
                            <p className="label-text-sec">{t("vendingMachines.Resolution")}*</p>
                            <Box sx={{ backgroundColor: inputBoxColor, borderRadius: '8px', padding: '0.5rem 1rem' }}>
                                <InputBase
                                    value={screen.resolution || ''}
                                    onChange={(e) => handleScreenChange(index, 'resolution', e.target.value)}
                                    placeholder="1920x1080"
                                    fullWidth
                                    sx={{ fontSize: '14px', color: textColor }}
                                />
                            </Box>
                            {errors.screens?.[index]?.resolution && (
                                <Typography sx={{ color: errorColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.screens[index].resolution}
                                </Typography>
                            )}

                         
                        </Grid>
                        <Grid className='resolution-div stategrid5' item xs={12} md={4}>
                          {/* Display Type */}
                            <p className="label-text-sec">{t("vendingMachines.DisplayType")}</p>
                            <Box sx={{ backgroundColor: inputBoxColor, borderRadius: '8px', padding: '0.5rem 1rem' }}>
                                <FormControl fullWidth>
                                    <Select
                                        value={screen.displayType || ''}
                                        onChange={(e) => handleScreenChange(index, 'displayType', e.target.value)}
                                        displayEmpty
                                        IconComponent={(props) => (
                                            <DropDownIcon color1={dropCircle} color2={dropIcon} {...props} />
                                        )}
                                        sx={{
                                            fontSize: '14px',
                                            color: textColor,
                                            backgroundColor: inputBoxColor,
                                            boxShadow: 'none',
                                            padding: 0,
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: 'none',
                                            },
                                            '& .MuiSelect-select': {
                                                 padding: '0.3rem 0.5rem',
                                                height: 'auto',
                                                display: 'flex',
                                                alignItems: 'center',
                                            },
                                        }}
                                    >
                                        <MenuItem value="">{t("vendingMachines.Select")}</MenuItem>
                                        <MenuItem value="LCD">{t("vendingMachines.LCD")}</MenuItem>
                                        <MenuItem value="LED">{t("vendingMachines.LED")}</MenuItem>
                                        <MenuItem value="OLED">{t("vendingMachines.OLED")}</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                            {errors.screens?.[index]?.displayType && (
                                <Typography sx={{ color: errorColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.screens[index].displayType}
                                </Typography>
                            )}

                         
                        </Grid>

                        {/* <Grid item xs={12} md={4}>
                        </Grid> */}

                    </Grid>
                </Box>
            ))}
        </Box>
    );
}

export default ScreenInformationSection;
